import { BoxProps, DrawerBody } from '../../../atoms';

export function SideOverlayBody(props: BoxProps): JSX.Element {
  return <DrawerBody {...props} />;
}
